import { render, staticRenderFns } from "./DeleteExpenses.vue?vue&type=template&id=1f429240&scoped=true"
import script from "./DeleteExpenses.vue?vue&type=script&lang=js"
export * from "./DeleteExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f429240",
  null
  
)

export default component.exports